import { useState, useEffect, useMemo } from 'react';
import { Form, WrapperSelect } from 'common/components';
import { Typography, Checkbox, Divider, Select } from 'antd';
import classnames from 'classnames';
import { useGetSupplierContacts } from 'pages/company-profile/components/tabs/system/supplier-management/hooks/useSupplierManager';
import './PermissionList.less';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const { Text } = Typography;

const PermissionList = (props) => {
  const {
    permissionList,
    checkable = true,
    initialSelectedPermission = [],
    onChange,
    newParam,
    handleContactSelect,
  } = props;

  const location = useLocation();
  const targetPaths = ['/product', '/products', '/qa-specification'];
  const isTargetPage = targetPaths.some((path) =>
    location.pathname.toLowerCase().includes(path)
  );

  useEffect(() => {
    clearSelection();
  }, [newParam]);

  const [selectedPermission, setSelectedPermission] = useState([]);

  const onCheckPermission = (permission) => (e) => {
    if (!checkable) return;

    const checked = e.target.checked;

    const newSelectedPermission = checked
      ? [...selectedPermission, permission]
      : selectedPermission.filter((selectedPermissionItem) => {
          return selectedPermissionItem !== permission;
        });

    setSelectedPermission(newSelectedPermission);

    onChange && onChange(newSelectedPermission);
  };

  const initSelectedPermission = () => {
    initialSelectedPermission?.length &&
      setSelectedPermission(initialSelectedPermission);
  };

  useEffect(() => {
    initSelectedPermission();
    //eslint-disable-next-line
  }, [initialSelectedPermission]);

  const renderPermissionList = (permissionItem) => {
    const isChecked = selectedPermission.includes(permissionItem.value);
    return (
      <div
        key={permissionItem?.value}
        className={classnames('permission-list__permission-item')}
      >
        <Checkbox
          checked={isChecked}
          onChange={onCheckPermission(permissionItem.value)}
          disabled={permissionItem?.disabled}
        >
          {permissionItem?.displayName}
        </Checkbox>
      </div>
    );
  };
  const clearSelection = () => {
    if (handleContactSelect) {
      handleContactSelect(null);
    }
  };

  const supplierId = newParam;
  const parameters = useMemo(() => ({ supplierId }), [supplierId]);

  const { data, Loading } = useGetSupplierContacts(parameters);

  const contacts = data?.data || [];

  const renderPermissionGroup = (permissionGroup) => {
    const { groupName, permissions } = permissionGroup;
    return (
      <div className={classnames('permission-list__group')} key={groupName}>
        <div className='permission-list__group-title'>
          <Text ellipsis>{groupName}</Text>
        </div>
        <div className='permission-list__permission-list'>
          {permissions?.length > 0 && permissions.map(renderPermissionList)}
        </div>
        {isTargetPage && (
          <div>
            <Divider
              style={{ color: '#333', fontWeight: 'normal' }}
              type='horizontal'
            />
            <div className='permission-list__group-title'>
              <Text ellipsis>Supplier Contact</Text>
            </div>
            <div className='permission-list__permission-list'>
              <WrapperSelect
                allowClear
                onSelect={handleContactSelect}
                onClear={clearSelection}
                placeholder='Please Select Contact'
                loading={Loading}
                style={{ minWidth: '100%' }}
              >
                {contacts.map((item) => (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </WrapperSelect>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className='permission-list'>
      {permissionList?.map(renderPermissionGroup)}
    </div>
  );
};

export default PermissionList;
